import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type MeasurementTool =
  | 'contrast'
  | 'zoom-in'
  | 'zoom-out'
  | 'pan'
  | 'measure-distance'
  | 'measure-angle'
  | 'reset'
  | 'texture'
  | 'area'
  | 'finalize-area'
  | null;

export interface MeasurementAction {
  type: MeasurementTool;
  payload?: any;
}

@Component({
  selector: 'app-measurement-sidebar',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './measurement-sidebar.component.html',
  styleUrls: ['./measurement-sidebar.component.scss'],
})
export class MeasurementSidebarComponent {
  @Input() activeTool: MeasurementTool = null;
  @Input() isContrastMode: boolean = false;
  @Input() isTextureMode: boolean = true;
  @Input() areaPointCount: number = 0;

  @Output() toolAction = new EventEmitter<MeasurementAction>();

  get isAreaInProgress(): boolean {
    return this.activeTool === 'area' && this.areaPointCount >= 3;
  }

  onToolClick(tool: MeasurementTool): void {
    this.toolAction.emit({ type: tool });
  }

  onFinalizeArea(): void {
    this.toolAction.emit({ type: 'finalize-area' as any });
  }
}
